import React from "react";
import Home1 from "./Home1/home1";
import Home2 from "./Home2/home2";
import Home3 from "./Home3/home3";

const HomeIndex = () => {
  return <Home3 />;
};

export default HomeIndex;
